import { Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectAccessAuthorization,
  selectRefreshAuthorization,
  updateAccessToken,
} from "../../../features/login/loginSlice";
import { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { ApiError, fetchWithResponse } from "../../../utils/EasyFetch";
import { LoginResponse } from "../../../features/login/types";
import { loading, notLoading } from "../../../features/loading/loadingSlice";
import { Task, TaskRow, taskToRow } from "../../../types/tasks";
import { formatDate } from "../../../utils/FormattingUtils";

const ActivitiesLayout = () => {
  const accessToken = useAppSelector(selectAccessAuthorization);
  const refreshToken = useAppSelector(selectRefreshAuthorization);
  const dispatch = useAppDispatch();
  const [tasks, setTasks] = useState<Task[]>([]);

  useEffect(() => {
    dispatch(loading());
    const cookies = new Cookies();
    fetchWithResponse<Task[]>(
      "GET",
      "/tasks",
      undefined,
      "Bearer " + accessToken
    )
      .then((t: Task[]) => {
        setTasks(t);
        dispatch(notLoading());
      })
      .catch((err: ApiError) => {
        if (err.statusCode === 401) {
          fetchWithResponse<LoginResponse>(
            "POST",
            "/auth/refresh",
            undefined,
            "Bearer " + refreshToken
          )
            .then((a: LoginResponse) => {
              cookies.set("accessToken", a.accessToken, {
                path: "/",
                sameSite: true,
              });
              dispatch(updateAccessToken(a.accessToken));
              dispatch(notLoading);
            })
            .catch((err: any) => {
              dispatch(notLoading());
            });
        } else {
          dispatch(notLoading());
        }
      });
  }, [accessToken, dispatch, refreshToken]);

  const uniqueTypes = Array.from(new Set(tasks.map((row) => row.type)));
  const typeFilters = uniqueTypes.map((type) => ({
    text: type,
    value: type,
  }));
  const uniqueStatuses = ["SUCCESSFUL", "ERROR"];
  const statusFilters = uniqueStatuses.map((status) => ({
    text: status,
    value: status,
  }));

  const columns = [
    {
      title: "Inserted",
      dataIndex: "inserted",
      key: "inserted",
      render: (text: string) => formatDate(text),
      sorter: (a: TaskRow, b: TaskRow) => a.inserted.localeCompare(b.inserted),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: statusFilters,
      onFilter: (value: any, record: TaskRow) => record.status === value,
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: (a: TaskRow, b: TaskRow) => a.type.localeCompare(b.type),
      filters: typeFilters,
      onFilter: (value: any, record: TaskRow) => record.type.includes(value),
    },
  ];

  return (
    <div>
      <Table
        dataSource={tasks.map(taskToRow)}
        columns={columns}
        pagination={false}
        bordered={true}
        showHeader={true}
        style={{ margin: "1%" }}
        expandable={{
          expandedRowRender: (record) => (
            <pre
              style={{
                margin: 0,
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {record.message}
            </pre>
          ),
          rowExpandable: (record) => !!record.message,
        }}
      />
    </div>
  );
};

export default ActivitiesLayout;
